import React from 'react'
import OnlineStatusDetailContainer from '../../SystemValues/OnlineStatus'
import DoorSensorComponent from '../../SystemValues/DoorSensor'
import { Col, Row } from 'react-bootstrap'
import styles from '../../MainPage/common/styles'
import { ChevronRight } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
const DoorSensor = ({ device, houseId, systemValuesComponent }) => {
  const navigate = useNavigate()
  const systemValueDoorSensorContainerComponents = {

    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={new Date()}
        selectedDeviceSelectedDayData={device}
      />
    ),
    doorStatus: (
      <DoorSensorComponent
        data={device}
      />
    ),
  }
  return (
    <div style={{
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
      padding: "20px",
      marginTop: "20px",
      borderRadius: "10px",
      backgroundColor: 'rgb(243 244 244)',
      position: 'relative'
    }}>
      <ChevronRight
        style={{ position: 'absolute', right: '20px', top: '20px', fontSize: '20px', fontWeight: '800' }}
        onClick={() => navigate(`/dashboard/${device.type}/${houseId}/${device.roomId}/${device.deviceId}`)}
      />
      <div>
        <h5 style={{ textAlign: 'left' }}> {device?.name ? `${device?.name} - ` : ""}
          {device.deviceId}</h5>
      </div>
      <Row style={{ ...styles.smallBoxContainer }} className="row g-2">
        {Object.keys(systemValueDoorSensorContainerComponents).filter(value => systemValuesComponent.includes(value)).map((key) =>
          <Col md={6} sm={12} key={key}>
            {React.cloneElement(systemValueDoorSensorContainerComponents[key], { key: `${key}-${device?.deviceId}` })}
          </Col>
        )}
      </Row>
    </div>
  )
}

export default DoorSensor